import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Flex, Button } from '@elparking/components'
import VehicleFilterBox from '../VehicleFilterBox'
import {
    BottomBarWrapper,
} from '../../ui/BottomBar'
import { FormattedMessage } from 'react-intl'

const CategoriesBoxModal = ({
    isShown,
    onClose,
    setFilters,
    filters,
    isLoading,
}) => {
    const [categories, setCategories] = useState(filters)

    const onSave = () => {
        setFilters(categories)
        onClose()
    }

    return (
        <Modal padding='0' isShown={isShown} width='600px' onClose={onClose}>
            <Flex padding='1em' width='100%' flexDirection='column'>
                <VehicleFilterBox key='vehicle-filter-box-modal' isModal filters={categories} isLoading={isLoading} setFilters={setCategories} />
            </Flex>
            <BottomBarWrapper>
                <Flex padding='1em' width='100%' alignItems='center' justifyContent='center'>
                    <Button onClick={onSave} width='100%'><FormattedMessage defaultMessage='Guardar' /></Button>
                </Flex>
            </BottomBarWrapper>
        </Modal>
    )
}

CategoriesBoxModal.propTypes = {
    isShown: PropTypes.bool,
    isLoading: PropTypes.bool,
    onClose: PropTypes.func,
    setFilters: PropTypes.func,
    filters: PropTypes.object,
}

export default CategoriesBoxModal
